import { render, staticRenderFns } from "./StudioBundledProduct.vue?vue&type=template&id=6bf0deba&"
import script from "./StudioBundledProduct.vue?vue&type=script&lang=ts&"
export * from "./StudioBundledProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports